export default "__VITE_ASSET__790756e7__"